import { useCheckPermissions } from '@/shared';
import { SaveGrupoActivos } from '../../shared/saveGrupoActivos';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateGrupoActivosPage {}

const CreateGrupoActivosPage: React.FC<CreateGrupoActivosPage> = () => {
  useCheckPermissions(PermissionsEnum.api_view_grupoactivo)

  return <SaveGrupoActivos titlePage="Crear grupo activos" />;
};

export default CreateGrupoActivosPage;
